
export interface UserSetting {
    id: number;
    userId: number;
    firebaseToken?: string;
    firebaseTokenIsInvalid?: boolean;
    cityId?: number;
    language?: string;
    nationality?: string;
    restrictedFeatures?: FeatureRuleName[];
}

export interface UpdateUserSetting {
    id?: number;
    userId?: number;
    firebaseToken?: string;
    firebaseTokenIsInvalid?: boolean;
    cityId?: number;
    language?: string;
    nationality?: string;
    restrictedFeatures?: FeatureRuleName[];
}

export enum FeatureRuleName {
    CanGenerateAiImage = 1,
    CanCreateTemplate = 2,
}

export const FeatureRuleNameList = [
    {value: 1, label: "Can Generate AI Image"},
    {value: 2, label: "Can Create Template"},
];
